<template lang="pug">
  #app
    router-view
</template>

<script>
export default {
  name: 'app',
  created () {
    // clear cache every time the site is loaded for now
    localStorage.clear()
    let mq = window.matchMedia('only screen and (max-width: 35.5em)')
    mq.addListener(this.mobile)
    this.mobile(mq)
  },

  methods: {
    mobile: function (mql) {
      if (mql.matches) {
        window._caam_intro = false
        window._caam_introBG = false
        // this.$ls.set('intro', false)
        // this.$ls.set('introBG', false)
      } else {
        window._caam_intro = true
        window._caam_introBG = true
        // this.$ls.set('intro', true)
        // this.$ls.set('introBG', true)
      }
    }
  }
}
</script>

<style lang="sass">
@import 'styles/main.sass'
</style>



// WEBPACK FOOTER //
// App.vue?c875f556